
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/product-list",
      function () {
        return require("private-next-pages/products/product-list.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/product-list"])
      });
    }
  